module.exports = __webpack_public_path__ + "static/3-6a0195ef3d97167e0e7832844dd4986d.png";